<template>
  <div class="lybBody">
    <div
      v-if="todoType != 'look'"
      style="
        position: absolute;
        right: 30px;
        top: 30px;
        font-size: 30px;
        color: #606266;
        cursor: pointer;
        z-index: 999;
      "
      @click="back"
    >
      <i class="el-icon-circle-close" />
    </div>
    <div v-show="!msgWindow">
      <!-- 标签页 -->
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="留言列表" name="msgList" />
        <el-tab-pane label="已答复" name="alreadyAnswered" />
        <el-tab-pane label="未答复" name="unanswered" />
      </el-tabs>
      <!-- 留言板主体 -->
      <div class="msgBodyList">
        <div
          style="display: flex; justify-content: space-between; padding: 0 20px"
        >
          <el-button
            type="primary"
            style="background-color: #4170ff; border: none"
            icon="el-icon-chat-dot-round"
            @click="todoMsg"
          >我要留言</el-button>

          <el-form
            v-if="isShow($options.name + '_answer')"
            ref="search"
            label-width="90px"
            style="display: flex; height: 39px"
            label-position="left"
          >
            <el-form-item label="单位名称:">
              <el-input
                v-model="dwMc"
                clearable
                placeholder="请输入单位名称"
              />
            </el-form-item>
            <el-button
              type="primary"
              style="background-color: #4170ff; border: none; margin-left: 30px"
              icon="el-icon-chat-dot-round"
              @click="search"
            >搜 索</el-button>
          </el-form>
        </div>

        <div class="userMsgList">
          <ul class="parentList">
            <li v-for="(item, index) in getMsgList" :key="index">
              <el-avatar
                style="margin-top: 30px; margin-left: 10px"
                :size="50"
                :src="item.avatar ? returnShowImg + item.avatar : circleUrl"
              />
              <div class="liBody">
                <h3>{{ item.title }}</h3>
                <span style="position: relative; width: 100%; display: block">
                  <span
                    class="oneSpan"
                  ><i class="el-icon-user" />{{ item.xm }}</span>
                  <span class="towSpan">
                    <i class="el-icon-office-building" />{{ item.dwMc }}
                  </span>
                  <span class="thireSpan">
                    <i class="el-icon-time" />{{ item.twSj }}
                  </span>
                  <span
                    class="detailSpan"
                    @click="lookDetail(item)"
                  >查看详情</span>
                  <img :src="item.isHf ? ydfImg : wdfImg" class="statusSpan">
                </span>
                <div class="msgBody">问题描述:{{ item.twContent }}</div>
                <div class="hfBody">
                  <div class="dfLabel">答复：</div>
                  <span class="dfText">{{
                    item.hfContent ? item.hfContent : "暂未答复"
                  }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <el-pagination
          v-if="total > 10"
          background
          style="text-align: right"
          layout="prev,pager,next,jumper,total,sizes"
          :total="total"
          :page-sizes="[10, 20]"
          :page-size="pagesize"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
      <el-empty v-if="total == 0" description="暂无信息" />
    </div>
    <div v-show="msgWindow" class="msgDialog">
      <span class="dialogTitle">{{
        todoType == "add" ? "新增留言" : "留言详情"
      }}</span>
      <el-form
        ref="msgForm"
        :model="msgForm"
        :rules="rules"
        :disabled="todoType == 'look'"
        label-position="right"
        class="_msgForm"
        label-width="90px"
      >
        <el-form-item label="标题" style="width: 100%" prop="title">
          <el-input v-model="msgForm.title" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="所属业务" style="width: 50%" prop="ywType">
          <el-select
            v-model="msgForm.ywType"
            placeholder="请选择所属业务"
            style="width: 100%"
          >
            <el-option
              v-for="item in ssywList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="所属区域" style="width: 50%" prop="value">
          <el-cascader
            ref="deptCascader"
            :key="cascaderKey"
            v-model="msgForm.value"
            placeholder="请选择所属区域"
            :show-all-levels="false"
            style="width: 100%"
            :props="props"
            @change="ssquChange"
          />
        </el-form-item>
        <el-form-item label="问题描述" style="width: 100%" prop="twContent">
          <div id="editor" />
        </el-form-item>
        <el-form-item
          v-show="todoType == 'look'"
          label="问题答复"
          style="width: 100%"
        >
          <div id="dfEditor" />
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button
          :type="todoType == 'add' ? '' : 'primary'"
          @click="closeDialog"
        >{{ todoType == "add" ? "取 消" : "返 回" }}</el-button>
        <el-button
          v-if="todoType == 'add'"
          type="primary"
          style="background: #4170ff; margin-left: 40px"
          @click="submit"
        >确 定</el-button>
        <el-button
          v-if="
            isShow($options.name + '_answer') &&
              !activeItem.isHf &&
              todoType === 'look'
          "
          type="primary"
          @click="answer"
        >回 复</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import E from 'wangeditor'
import {
  getTypeList,
  addMessage,
  getMsgManage,
  saveFileYs,
  getMessageInfo,
  editMessage
} from '@/assets/js/lyb.js'
import { getXzqTree, getXzqTreeS } from '@/assets/js/step2.js'
import { getToken, returnShowPic } from '@/assets/js/common.js'
export default {
  name: 'Lyb',
  data() {
    const titleValidator = (rule, value, callback) => {
      if (!value && this.todoType != 'look') {
        callback(new Error('请输入标题'))
      }
      callback()
    }
    const ywTypeValidator = (rule, value, callback) => {
      if (!value && this.todoType != 'look') {
        callback(new Error('请选择所属业务'))
      }
      callback()
    }
    const dataValidator = (rule, value, callback) => {
      if (!value && this.todoType != 'look') {
        callback(new Error('请选择所属区域'))
      }
      callback()
    }
    const twContentValidator = (rule, value, callback) => {
      if (!value && this.todoType != 'look') {
        callback(new Error('请输入问题描述'))
      }
      callback()
    }
    return {
      // 图片显示前缀
      returnShowImg: returnShowPic(),
      circleUrl: require('../assets/img/rstep3t.png'), // 默认头像
      ydfImg: require('../assets/img/ydf.png'), // 以答复icon
      wdfImg: require('../assets/img/wdf.png'), // 未答复icon
      rules: {
        //
        title: [
          { required: true, validator: titleValidator, trigger: 'change' }
        ],
        ywType: [
          { required: true, validator: ywTypeValidator, trigger: 'change' }
        ],
        value: [
          { required: true, validator: dataValidator, trigger: 'change' }
        ],
        twContent: [
          { required: true, validator: twContentValidator, trigger: 'change' }
        ]
      },
      todoType: '', // 操作类型

      dwMc: '',

      msgForm: {
        // 留言板表单
        value: []
      },
      cascaderKey: 0, // 解决数据渲染问题
      activeName: 'msgList',
      activeItem: {}, // 当前数据
      msgWindow: false,
      editor: null, // 富文本选择器
      dfEditor: null, // 富文本选择器
      getMsgList: [], // 获取的列表
      ssywList: [], // 所属业务list
      xzqhTree: [], // 行政区划list
      total: 0, // 总数
      pagesize: 10, // 页大小
      currentPage: 1, // 当前页
      props: {
        lazy: true, // 开启懒加载
        checkStrictly: true,
        lazyLoad(node, resolve) {
          const { level } = node
          setTimeout(() => {
            if (level == 0) {
              getXzqTree().then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            } else {
              getXzqTreeS(node.value).then((res) => {
                const nodes = res.data.data.map((item) => ({
                  value: item.value,
                  label: item.label,
                  leaf: !item.leaf
                }))
                resolve(nodes)
              })
            }
          }, 200) // 解决数据回显时异步
        }
      }
    }
  },
  computed: {
    ...mapGetters({ isShow: 'result' })
  },
  mounted() {
    getTypeList().then((e) => {
      this.ssywList = e.data.data // 所属业务KV
    })
    this.search() // 预加载
    setInterval(function() {
      // 用于级联选择器点击标签页可以选中对应项
      document.querySelectorAll('.el-cascader-node__label').forEach((el) => {
        el.onclick = function() {
          if (this.previousElementSibling) this.previousElementSibling.click()
        }
      })
    }, 1000)
    this.$nextTick(function() {
      // 初始化富文本
      this.initEditor()
      this.initDfEditor()
    })
  },
  methods: {
    lookDetail(item) {
      // 查看详情
      getMessageInfo(item.id).then((e) => {
        this.msgWindow = true // 开启留言板
        this.todoType = 'look' // 操作类型
        this.msgForm.id = e.data.data.id // 答复时接口参数
        this.msgForm.title = e.data.data.title // 标题
        this.msgForm.ywType = e.data.data.ywType + '' // 业务类型
        this.$nextTick(() => {
          e.data.data.province
            ? (this.msgForm.value[0] = e.data.data.province)
            : ''
          e.data.data.city ? (this.msgForm.value[1] = e.data.data.city) : ''
          e.data.data.county
            ? (this.msgForm.value[2] = e.data.data.county)
            : ''
          this.cascaderKey++ // 解决级联选择器数据回显渲染问题
        })
        this.editor.txt.html(e.data.data.twContent) // 用户富文本回显
        this.dfEditor.txt.html(e.data.data.hfContent) // 答复富文本回显
        this.editor.disable() // 用户富文本不可编辑
        if (this.isShow(this.$options.name + '_answer') && !item.isHf) {
          this.dfEditor.enable()
        } else {
          this.dfEditor.disable()
        }
        this.activeItem = item // 当前留言数据  主要用于获取答复状态
      })
    },
    // tab标签页切换时 查询列表 、已回复、未回复
    handleClick() {
      // 重置查询时的页码
      this.currentPage = 1
      this.pagesize = 10
      this.search()
    },
    // 查询列表
    search() {
      const obj =
        this.activeName === 'msgList'
          ? null
          : this.activeName === 'alreadyAnswered'
      getMsgManage({
        page: this.currentPage,
        size: this.pagesize,
        param: { isHf: obj, dwMc: this.dwMc }
      }).then((e) => {
        this.getMsgList = e.data.data.rows
        this.total = e.data.data.total
      })
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.search()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.search()
    },
    // 回复留言
    answer() {
      editMessage({
        id: this.msgForm.id,
        hfContent: this.msgForm.hfContent
      }).then((e) => {
        this.$message.success('回复成功！')
        this.closeDialog()
      })
    },

    // 提交留言
    submit() {
      this.$refs['msgForm'].validate((valid) => {
        if (valid) {
          addMessage(this.msgForm).then((e) => {
            this.$message.success('留言成功!')
            this.closeDialog()
          })
        }
      })
    },
    // 所属区域change
    ssquChange(val) {
      val.length >= 1 ? (this.msgForm.province = val[0]) : ''
      val.length >= 2 ? (this.msgForm.city = val[1]) : ''
      val.length >= 3 ? (this.msgForm.county = val[2]) : ''
    },
    // 初始化富文本
    initEditor() {
      if (this.editor) return
      this.editor = new E('#editor') // 通过id拉取div
      this.editor.config.menuTooltipPosition = 'up' // 菜单位置
      this.editor.config.zIndex = 1 // 层级  解决上方选择器的浮层显示异常问题
      this.editor.config.uploadImgMaxSize = 500 * 1024 // 500k  限制文件大小
      this.editor.config.showLinkImg = false // 隐藏插入网络图片的功能
      this.editor.config.placeholder =
        '请填写您遇到的问题(可上传小于500k的图片)'
      this.editor.config.uploadFileName = 'file'
      this.editor.config.uploadImgAccept = [
        // 限制上传文件类型
        'jpg',
        'jpeg',
        'png',
        'gif',
        'bmp',
        'webp'
      ]
      this.editor.config.uploadImgHeaders = {
        // 自定义header
        Authorization: getToken()
      }
      this.editor.config.onchange = (html) => {
        // html 绑定值
        this.msgForm.twContent = html
        // this.content = editor.txt.text();  纯文本
      }
      this.editor.config.customAlert = (s, t) => {
        s.indexOf('0.48828125M') != -1 ? (s = '上传图片不可大于500kb') : ''
        // 自定义消息提示
        switch (t) {
          case 'success':
            this.$message.success(s)
            break
          case 'info':
            this.$message(s)
            break
          case 'warning':
            this.$message.warning(s)
            break
          case 'error':
            this.$message.error(s)
            break
          default:
            this.$message(s)
            break
        }
      }
      this.editor.config.menus = [
        // 自定义菜单配置
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'image', // 插入图片
        // "table", // 表格
        // "code", // 插入代码
        'undo', // 撤销
        'redo' // 重复
      ]
      this.editor.config.customUploadImg = (files, insert) => {
        var data = new FormData()
        data.append('file', files[0])
        saveFileYs(data).then((e) => {
          if (e.data.code == '000000') {
            this.editor.cmd.do(
              'insertHTML',
              `<img src=${this.returnShowImg + e.data.data.url} alt="">`
            )
          }
        })
      }
      this.editor.create()
    },
    initDfEditor() {
      if (this.dfEditor) return
      this.dfEditor = new E('#dfEditor') // 通过id拉取div
      this.dfEditor.config.menuTooltipPosition = 'up' // 菜单位置
      this.dfEditor.config.zIndex = 1 // 层级  解决上方选择器的浮层显示异常问题
      this.dfEditor.config.uploadImgMaxSize = 500 * 1024 // 500k  限制文件大小
      this.dfEditor.config.showLinkImg = false // 隐藏插入网络图片的功能
      this.dfEditor.config.placeholder = '暂无答复'
      this.dfEditor.config.uploadFileName = 'file'
      this.dfEditor.config.uploadImgAccept = [
        // 限制上传文件类型
        'jpg',
        'jpeg',
        'png',
        'gif',
        'bmp',
        'webp'
      ]
      this.dfEditor.config.uploadImgHeaders = {
        // 自定义header
        Authorization: getToken()
      }
      this.dfEditor.config.onchange = (html) => {
        // html 绑定值
        this.msgForm.hfContent = html
        // this.content = dfEditor.txt.text();  纯文本
      }
      this.dfEditor.config.customAlert = (s, t) => {
        s.indexOf('0.48828125M') != -1 ? (s = '上传图片不可大于500kb') : ''
        // 自定义消息提示
        switch (t) {
          case 'success':
            this.$message.success(s)
            break
          case 'info':
            this.$message(s)
            break
          case 'warning':
            this.$message.warning(s)
            break
          case 'error':
            this.$message.error(s)
            break
          default:
            this.$message(s)
            break
        }
      }
      this.dfEditor.config.menus = [
        // 自定义菜单配置
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        'link', // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        'image', // 插入图片
        'undo', // 撤销
        'redo' // 重复
      ]
      this.dfEditor.config.customUploadImg = (files, insert) => {
        var data = new FormData()
        data.append('file', files[0])
        saveFileYs(data).then((e) => {
          if (e.data.code == '000000') {
            this.dfEditor.cmd.do(
              'insertHTML',
              `<img src=${this.returnShowImg + e.data.data.url} alt="">`
            )
          }
        })
      }
      this.dfEditor.create()
    },
    // 关闭留言页
    close() {
      this.msgWindow = false // 关闭窗口
      this.msgForm = {
        value: []
      }
      this.todoType = ''
      this.editor.txt.clear()
      this.dfEditor.txt.clear()
      this.$refs['msgForm'].resetFields()
    },
    // 关闭留言页并刷新
    closeDialog() {
      this.msgWindow = false // 关闭窗口
      /* 还原查询参数 避免标签页与查出的数据不对应 */
      this.pagesize = 10
      this.search()
      /* 清空表单 */
      this.msgForm = {
        value: []
      }
      this.todoType = ''
      this.editor.txt.clear()
      this.dfEditor.txt.clear()
      this.$refs['msgForm'].resetFields()
    },
    // 打开留言页
    todoMsg() {
      this.msgWindow = true
      this.todoType = 'add'
      this.editor.enable()
    },
    // 在列表页 返回主页  在留言页返回列表页
    back() {
      if (!this.msgWindow) {
        this.$parent.xuanfumianbanShow = true
      } else {
        this.msgWindow = !this.msgWindow
      }
    }
  }
}
</script>

<style lang='less' scoped>
.lybBody {
  position: relative;
  padding-bottom: 50px;
  .msgDialog {
    padding: 80px 50px;
    .dialogTitle {
      display: block;
      text-align: center;
      font-size: 26px;
      font-weight: 600;
    }
  }
  .msgBodyList {
    padding: 0px 20px;
  }
  .userMsgList {
    .parentList {
      li {
        list-style: none;
        display: flex;
        justify-content: space-between;
        .liBody {
          width: calc(100% - 100px);
        }
        .oneSpan {
          margin-right: 20px;
        }
        .towSpan {
          margin-left: 20px;
          margin-right: 20px;
        }
        .thireSpan {
          margin-left: 20px;
        }
        .detailSpan {
          position: absolute;
          right: 100px;
          bottom: 20px;
          height: 32px;
          line-height: 32px;
          cursor: pointer;
        }
        .statusSpan {
          position: absolute;
          right: 10px;
          bottom: 20px;
        }
        .msgBody {
          margin-top: 10px;
          border: 1px solid #ccc;
          padding: 15px;
          word-break: break-all;
        }
        .hfBody {
          padding: 15px 0px 15px 15px;
          display: flex;
          word-break: break-all;
          .dfLabel {
            min-width: 60px;
            color: rgb(19, 101, 211);
            font-weight: 600;
            font-size: 20px;
            line-height: 60px;
            height: 60px;
          }
          .dfText {
            padding-left: 15px;
            /*  display: block; */
            width: 95%;
            line-height: 60px;
            /* height: 60px; */
            background-color: rgb(242, 245, 249);
            word-break: break-all;
          }
        }
      }
    }
  }
  /deep/.el-tabs {
    //底部线条
    .el-tabs__active-bar {
      border-radius: 50px;
    }
    /* tabs的header外边距 */
    .el-tabs__header {
      padding: 30px 20px;
      margin: 0px;
    }
    //选项卡
    .el-tabs__item {
      font-size: 18px;
    }
    .el-tabs__content {
      padding: 0px 20px;
    }
  }
  ._msgForm {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 50px;
  }
}
</style>
